import { BarChart3, BookOpen, Gauge, Link2, LockKeyhole, Plus, Settings, ShieldCheck } from "lucide-react";
import { NavLink, Outlet } from "react-router-dom";
import { useAuth } from "../auth/useAuth";
import { Brand } from "./Brand";
import { useQuickLock } from "../privacy/QuickLockContext";

const navItems = [
  { to: "/app", label: "Ticker", icon: Gauge, end: true },
  { to: "/app/history", label: "Logs", icon: BookOpen },
  { to: "/app/new", label: "Log", icon: Plus, featured: true },
  { to: "/app/insights", label: "Insights", icon: BarChart3 },
  { to: "/app/connections", label: "Connect", icon: Link2 },
  { to: "/app/settings", label: "Settings", icon: Settings },
];

export function AppShell() {
  const { profile, isAdmin } = useAuth();
  const { lock } = useQuickLock();
  return (
    <div className={profile?.discreetMode ? "app-shell discreet" : "app-shell"}>
      <header className="app-header">
        <Brand compact />
        <div className="app-header__tools">
          <button className="header-lock" onClick={lock} aria-label="Quick Lock" title="Quick Lock"><LockKeyhole /><span>Lock</span></button>
          {isAdmin ? <NavLink className="admin-shortcut" to="/app/admin"><ShieldCheck /> Admin</NavLink> : null}
          <div className="app-header__alias" title="Signed-in profile"><span aria-hidden="true">●</span>{profile?.alias}</div>
        </div>
      </header>
      <main className="app-content"><Outlet /></main>
      <nav className="bottom-nav" aria-label="Primary navigation">
        {navItems.map(({ to, label, icon: Icon, featured, end }) => (
          <NavLink key={to} to={to} end={end} className={({ isActive }) => `${featured ? "bottom-nav__featured " : ""}${isActive ? "is-active" : ""}`}>
            <Icon aria-hidden="true" /><span>{label}</span>
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
